import React, { useId, Children, cloneElement, isValidElement } from 'react';
import './FormField.css';

function FormField({
  label,
  htmlFor,
  required = false,
  error = null,
  helper = null,
  children,
  className = '',
}) {
  const generatedId = useId();
  const fieldId = htmlFor || generatedId;
  const errorId = `${fieldId}-error`;
  const helperId = `${fieldId}-helper`;

  const describedBy = [error ? errorId : null, helper ? helperId : null]
    .filter(Boolean)
    .join(' ') || undefined;

  const wired = Children.map(children, (child) => {
    if (!isValidElement(child)) return child;
    return cloneElement(child, {
      id: child.props.id || fieldId,
      'aria-describedby': describedBy,
      error: !!error || child.props.error,
    });
  });

  return (
    <div className={`ui-form-field ${error ? 'ui-form-field--error' : ''} ${className}`}>
      {label && (
        <label className="ui-form-field__label" htmlFor={fieldId}>
          {label}
          {required && <span className="ui-form-field__required" aria-hidden="true">*</span>}
        </label>
      )}
      {wired}
      {error && (
        <span className="ui-form-field__error" id={errorId} role="alert">
          {error}
        </span>
      )}
      {!error && helper && (
        <span className="ui-form-field__helper" id={helperId}>
          {helper}
        </span>
      )}
    </div>
  );
}

export default FormField;
